import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map'
import { Usuario } from '../models/usuario';
import { environment } from '../../environments/environment';


@Injectable()
export class AuthService {
  public token: string;
  public username: string;
  public roles: string;
  constructor(private http: Http) {
    // set token if saved in local storage
    var currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.token = currentUser && currentUser.token;
    this.username = currentUser && currentUser.username;
    this.roles = currentUser && currentUser.roles;
   }

   login(username, password): Observable<boolean> {
        var headers = new Headers();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');

        var body = `username=${username}&password=${password}&grant_type=password&client_id=${environment.CLIENT_ID}`;

        return this.http.post(`${environment.API_ENDPOINT}/token`, body, { headers: headers})
            .map((response: Response) => {
                // login successful if there's a jwt token in the response
                let token = response.json() && response.json();
                let access_token = token.access_token;
                if (access_token) {
                    // set token property
                    this.token = access_token;                    
                    this.username = username;
                    this.roles = token.roles;
                    // store username and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify({ username: username, token: access_token, roles: token.roles }));
 
                    // return true to indicate successful login
                    return true;
                } else {
                    // return false to indicate failed login
                    return false;
                }
            }).catch((error:any)=>{return Observable.of(false);});;
   }

  logout(): void {
        // clear token remove user from local storage to log user out
        this.token = null;
        localStorage.removeItem('currentUser');
    }

}



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/services/auth.service.ts